import React, {useState} from 'react'
import Button from '../Button'
import { handleSubmitCode } from '../../Actions/BackofficeLogin.action'
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { useDispatch } from 'react-redux';
import Input from '../Inputs/Input';

const BackofficeCodeForm = () => {
    const dispatch = useDispatch();
    const {
        username,
        showQrCode,
        showCodeInput,
        qrCode,
        error,
        isLoading,
        loginToken
    } = useTypedSelector((state) => state.backofficeLogin);
    
    const [code, setCode] = useState<string>();
    
    const submitCode = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        dispatch(handleSubmitCode(e, username, code, loginToken));
    }

    return (
        <div className='flex flex-col items-center justify-center gap-4 w-full'>
            {showQrCode &&
                <div id="qrCodeSection" className='flex flex-col items-center justify-center gap-4 w-full'>
                    <p>Scan this QR Code with Google Authenticator app:</p>
                    <img src={qrCode} alt="QR Code" />
                </div>
            }

            {showCodeInput &&
                <div id="codeSection" className='flex flex-col items-center justify-center gap-4 w-full'>
                    <form id="codeForm" className='flex flex-col gap-4 w-full px-13' method="post" onSubmit={submitCode}>
                        <Input
                            label="Enter the 6-digit code from google authenticator app"
                            inputSize="large"
                            wrapperClassName="input__wrapper"
                            placeholder="Code"
                            onChange={(e) => (setCode(e.target.value))}
                            disabled={isLoading}
                            type="number"
                            id="code"
                            autoComplete="current-code"
                        />
                        <span className='text-md'>If you don't have a google authenticator code, contact your administrator</span>
                        <div className="text-md text-[#EF4444] min-h-[16px]">
                            {error?.Code && <span>{error.Code}</span>}
                            {error?.General && <span>{error.General}</span>}
                        </div>
                        <Button
                            btnSize="large"
                            btnType="primary"
                            fullwidth={true}
                            type="submit"
                            className="submit"
                            disabled={code === '' && isLoading}
                        >Submit Code</Button>
                    </form>
                </div>
            }
        </div>

    )
}

export default BackofficeCodeForm